import { ICompany, IStandardSetting } from '../types/company'
import { GlobalSettingActions } from '../actions/companyActions'
import * as constants from '../actions/constants'

export const initialCompany: ICompany = {
  id: '',
  name: '',
  street: '',
  number: '',
  postal_code: '',
  city: '',
  country: '',
  email: '',
  phone_number: ''
}

export const initialStandardSetting: IStandardSetting = {
  id: '',
  language: '',
  currency: ''
}


export const company = (state: ICompany = initialCompany, action: GlobalSettingActions): ICompany => {
  switch (action.type) {
    case constants.GET_COMPANY_SUCCESS:
    case constants.CREATE_COMPANY_SUCCESS:
    case constants.UPDATE_COMPANY_SUCCESS:
      return action.company

    default:
      return state
  }
}

export const companies = (state: ICompany[] = [], action: GlobalSettingActions): ICompany[] => {
  switch (action.type) {
    case constants.GET_COMPANIES_SUCCESS:
      return action.companies

    default:
      return state
  }
}

export const standardSetting = (state: IStandardSetting = initialStandardSetting, action: GlobalSettingActions): IStandardSetting => {
  switch (action.type) {
    case constants.GET_STANDARD_SETTING_SUCCESS:
    case constants.CREATE_STANDARD_SETTING_SUCCESS:
    case constants.UPDATE_STANDARD_SETTING_SUCCESS:
      return action.standardSetting

    default:
      return state
  }
}

export const standardSettings = (state: IStandardSetting[] = [], action: GlobalSettingActions): IStandardSetting[] => {
  switch (action.type) {
    case constants.GET_STANDARD_SETTINGS_SUCCESS:
      return action.standardSettings

    default:
      return state
  }
}
